"use client";

import { c as _c } from "react/compiler-runtime";
import { likeBlog, unlikeBlog } from "@/actions/blog";
import { Button } from "@/components/ui/button";
import { ButtonWithCountContainer } from "@/components/utility/button-with-count-container";
import { cn } from "@/utils/helpers";
import { tryCatch } from "@/utils/validators";
import { useAuth } from "@clerk/nextjs";
import { ThumbsUp } from "lucide-react";
import { useState } from "react";
import Confetti from "react-dom-confetti";
import { toast } from "sonner";
type BlogLikeButtonProps = {
  initialLikesCount: number;
  initialLikeStatus: boolean;
  blogId: string;
};
export default function BlogLikeButton(t0) {
  const $ = _c(26);
  const {
    initialLikesCount,
    initialLikeStatus,
    blogId
  } = t0;
  const [likesCount, setLikesCount] = useState(initialLikesCount);
  const [hasLiked, setHasLiked] = useState(initialLikeStatus);
  const [showConfetti, setShowConfetti] = useState(false);
  const {
    userId
  } = useAuth();
  let t1;
  if ($[0] !== blogId || $[1] !== hasLiked || $[2] !== initialLikeStatus || $[3] !== initialLikesCount || $[4] !== userId) {
    t1 = async function handleLikeToggle() {
      if (!userId) {
        toast.warning("Please sign in to like this blog.");
        return;
      }
      setHasLiked(_temp);
      setLikesCount(prev_0 => hasLiked ? prev_0 - 1 : prev_0 + 1);
      setShowConfetti(!hasLiked);
      const {
        error
      } = hasLiked ? await tryCatch(unlikeBlog(blogId)) : await tryCatch(likeBlog(blogId));
      if (error) {
        setHasLiked(initialLikeStatus ?? false);
        setLikesCount(initialLikesCount ?? 0);
        toast.error("Could not toggle like");
        return;
      }
      setShowConfetti(false);
    };
    $[0] = blogId;
    $[1] = hasLiked;
    $[2] = initialLikeStatus;
    $[3] = initialLikesCount;
    $[4] = userId;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleLikeToggle = t1;
  const t2 = hasLiked ? "bg-foreground hover:bg-foreground/80" : "hover:bg-foreground";
  let t3;
  if ($[6] !== t2) {
    t3 = cn("group size-12 rounded-full", t2);
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== handleLikeToggle) {
    t4 = () => handleLikeToggle();
    $[8] = handleLikeToggle;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = hasLiked ? "text-background" : "group-hover:-rotate-12 group-hover:text-background";
  let t6;
  if ($[10] !== t5) {
    t6 = cn("transition-all duration-200", t5);
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <ThumbsUp size={24} className={t6} />;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== showConfetti) {
    t8 = <Confetti active={showConfetti} />;
    $[14] = showConfetti;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t3 || $[17] !== t4 || $[18] !== t7 || $[19] !== t8) {
    t9 = <Button variant="outline" size="icon" className={t3} onClick={t4}>{t7}{t8}</Button>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== likesCount) {
    t10 = <p className="text-center text-sm">Likes: {likesCount}</p>;
    $[21] = likesCount;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t9) {
    t11 = <ButtonWithCountContainer>{t9}{t10}</ButtonWithCountContainer>;
    $[23] = t10;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
}
function _temp(prev) {
  return !prev;
}